module.exports = __webpack_public_path__ + "static/media/tos.bd177a97.pdf";